import { connect } from 'react-redux';
import TodoItemQuestion from '../components/TodoItemQuestion/TodoItemQuestion';
import NewFormDialog from '../components/TodoItemQuestion/TodoItemQuestionNewFormDialog';
import CrudTable from '../components/CrudTable/CrudTable';
import crudActionCreators from '../actions/crudActionCreators';
import { bindActionCreators } from 'redux';

let actions = {};



const mapStateToProps = (state, props) => {


  return ({ ...state,
    listData: state.todo_item_questions,
    title: 'Todo Item - Questions',
    NewFormDialog,
    CrudRow: TodoItemQuestion,
  }
 )};

const mapDispatchToProps = (dispatch, props) => {
  let cac = {};
  cac = new crudActionCreators('todo_item_question', props.location.pathname.replace(/\/$/, ''));
  return bindActionCreators({
    loadAction: cac.loadAction,
    addAction: cac.addAction,
    deleteAction: cac.deleteAction,
    putAction: cac.putAction,
    updateAction: cac.updateAction,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CrudTable);
